import React, {Component} from 'react'
import {connect} from 'react-redux';
import {change} from 'redux-form';
import validator from 'validator';

//material ui
import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';

//Action
import {getCommunityById} from '../../actions/communityActions'
import {PostRegirtrationInfo} from '../../actions/connectAppActions'

//Engage
import {SimpleSelect} from '../../utils/engageComponents';


 export class ConnectInvitationModal extends Component{
    constructor(props){
        super()
        
        this.state={
            modalInfo:props.modalInfo? props.modalInfo : undefined,
            residents: props.residents? props.residents.map(res => ({_id:res._id? res._id : undefined, name: (res.firstName ? res.firstName : '') + ' ' + (res.lastName? res.lastName : '')  , pictureUrl: res.pictureUrl?res.pictureUrl : '', communityId: res.communityId})) : undefined,
            //isSingleresident
            isSingleResident : props.residentSelected? true: false,
            //Resident Selected
            residentSelected : props.residentSelected? {_id:props.residentSelected._id? props.residentSelected._id : undefined, name: (props.residentSelected.firstName ? props.residentSelected.firstName : '') + ' ' + (props.residentSelected.lastName? props.residentSelected.lastName : '')  , pictureUrl: props.residentSelected.pictureUrl?props.residentSelected.pictureUrl : '', communityId: props.residentSelected.communityId} : undefined,
            errorResidentSelected: false,
            errorTextResidentSelected: undefined,
            //Email
            emailText: undefined,
            validEmail: false,
            errorText:undefined,
            //Resize
            rootFontSize:{
                name:'xs',
                fontSize:'58%',
                maxWidht:970,            
            },  
        }
    };

    componentDidMount(){
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    };

    resize() {
        this.setState({isMobile: window.innerWidth <= 960});

        const sizes={
           xs: {
                name:'xs',
                fontSize:'58%',
                maxWidht:600,            
            },
            sm: {
                name:'sm',
                fontSize:'60%',
                maxWidht:1024,            
            },
            md: {
                name:'md',
                fontSize:'80%',
                maxWidht:1880,            
            },
            lg: {
                name:'lg',
                fontSize:'100%',
                maxWidht:1920,            
            },
        };
   
        const windowWidht = window.innerWidth ;
        const windowHeiht = window.innerHeight;
   
        let rootFontSize= sizes.xs;
   
        if(windowWidht > sizes.md.maxWidht){
            rootFontSize=  sizes.lg;
        }else if(windowWidht > sizes.sm.maxWidht){
            rootFontSize=  sizes.md;
        }else if(windowWidht > sizes.xs.maxWidht){
            rootFontSize=  sizes.sm;
        }else {
            rootFontSize=  sizes.xs;
        }
   
   
        this.setState({
            rootFontSize: rootFontSize,
            windowWidht:windowWidht,
            windowHeiht:windowHeiht,
        });
    }
   
    
      //#region Modal

      //percentages
      modalWidth= 35;
      modalHeight= 55;

      Modal ={
        paperModal:{
            backgroundColor:'#1f1f1f',
            padding:'6px',
            width:this.modalWidth+'%',
            height:this.modalHeight+'%',
            position:'relative', 
            top: 50- (this.modalHeight/2)+ '%', 
            left: 50 - (this.modalWidth /2)+'%',
            overflow:'auto'
        },
    }
    //#endregion

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker });

        
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false })
    };

    //onSubmit
    onSubmitHandler(){
        const objToSend = this.getObjToSend();
        
        if(objToSend && objToSend.residentId){
            this.props.PostRegirtrationInfo(objToSend);
            this.closeModal();
        } 
    };


    getObjToSend = () =>{
        
        const objToSend = {};
        let error = false;

        if(this.state.residentSelected){

            const residentId = this.state.residentSelected._id && this.state.residentSelected._id.length >0? this.state.residentSelected._id : undefined;
            const residentName = this.state.residentSelected.name && this.state.residentSelected.name.length > 0? this.state.residentSelected.name : undefined ;
            const residentPictureUrl = this.state.residentSelected.pictureUrl && this.state.residentSelected.pictureUrl.length > 0 ? this.state.residentSelected.pictureUrl : undefined;

            if(residentId && residentName && residentPictureUrl){
                 objToSend.residentId = residentId;
                 objToSend.residentName = residentName;
                 objToSend.residentPictureUrl = residentPictureUrl;

            } else{
              error = true;        
            }

        } else{
            error = true;
        }


        if(this.props.communityData && this.state.residentSelected){

            const community = this.props.communityData.find((comm) => comm._id === this.state.residentSelected.communityId)
            if(community){
                const communityName =community.name;
                const communityId = community.communityId;

                if(communityName && communityId){
                    objToSend.communityId = communityId;
                    objToSend.communityName = communityName;

                } else {
                    error = true;
                }
            } else{
                error = true;
            }
        } else {
            error = true;
        }

        if(this.state.emailText && this.state.emailText.length > 0  && this.state.validEmail){
            objToSend.email = this.state.emailText;
        } else {
            error = true;
        }
        
        return !error?  objToSend : undefined;
    }

    closeModal(){
        this.cleanModal();
        this.props.onClose();
    };

    cleanModal(){
        this.setState({
            //communityId
            communityId: undefined,
            //defaultColor
            defaultColor:'#959494',
            //ColorPicker
            displayColorPicker:false,
            colorSelected:undefined,
            //categoryIconSelected
            categoryIconSelectedUrl: undefined,
        })


        this.props.dispatch(change('AddCategoryForm','CategoryName', ''));
        this.props.dispatch(change('AddCategoryForm','CategoryColor',  ''));
        this.props.dispatch(change('AddCategoryForm','CategoryIconUrl',  ''));
    };

    GetCategoryBadge(categoryName){
        let categoryWords = categoryName.split(' ');

        categoryWords = categoryWords.filter(item => item !== '&' );

        const CategoryBadge= categoryWords.map(word =>word.charAt(0).toUpperCase()).join('').slice(0,2);

        return CategoryBadge;
    };




    //#region Inner Compoonencts
    //#region  Resident Component
    residentChangeHandler = (newItem) =>{

        let error = false;
        let errorText = 'select a resident';

        if(newItem){
            errorText =  undefined;
        } else{
            error = true;
        }

        this.setState({residentSelected: newItem, errorResidentSelected: error, errorTextResidentSelected: errorText});
    };

    InnerResidentComponent = ({community}) =>{

        const styles={
            title:{
                color:'#686868',
                fontSize:'20px'
            }
        }
        return(
            <Grid item container xs={12}>
                <Grid item style={{...styles.title}}>Resident</Grid>
                <Grid item container justify='center'>
                {
                   
                    <Grid item  xs={12} style={{}} justify='center'>
                        <SimpleSelect
                            idToSet='connect_invitation_resident_select'
                            label={'Resident'}
                            onChangeHandler = { (e,newItem) => this.residentChangeHandler(newItem)}
                            optionsItemsIconsData = {this.state.residents? this.state.residents : []}
                            selected = {this.state.residentSelected? this.state.residentSelected :{}}
                            disabled= { this.state.isSingleResident? this.state.isSingleResident : false}
                            error={this.state.errorResidentSelected? this.state.errorResidentSelected : undefined}
                            helperText = {this.state.errorTextResidentSelected? this.state.errorTextResidentSelected : undefined}
                            autoFocus={(this.state.isSingleResident===true)?false:true}
                        />
                                       
                    </Grid>
                   
                }
                </Grid>

              
            </Grid>
        );
    }    
    //#endregion

    //#region  Familiar Componnet
    familiarEmailHandler = (emailText) =>{
        let validEmail = validator.isEmail(emailText);
        let errorText = 'error';

        if(emailText && emailText.length > 0){
            if(validEmail){
                errorText = undefined;
            } else{
                errorText = 'error in email format';
            }
        } else{
            errorText='please enter email';
        }

        this.setState({
            emailText: emailText,
            validEmail: validEmail,
            errorText:errorText
        });  

    };

    InnerFamiliarComponent = () =>{
        
        const styles={
            title:{
                color:'#686868',
                fontSize:'20px'
            },
            button:{
                marginTop:'15px',
                fontSize:'18px',
                width:'150px',
                height:'48px',
                padding:'10px',
                fontFamily:'Gotham-Bold',
                marginLeft:'40px',
                marginRight:'40px'
            }
        }

        return(
            <Grid item container xs={12}>
                <Grid item container id='connectInvitation_Label' style={{...styles.title}}>
                    Family Member Information
                </Grid>
                <Grid item container>
                    <TextField
                        id="connect_invitation_email"
                        style={{width:'100%', marginLeft:'auto', marginRight:'auto', marginTop:'auto', marginBottom:'0', paddingRight:'15px'}}  
                        label={'Email'}
                        placeholder={'xxx@yyy.zzz'}
                        error={!this.state.validEmail}
                        helperText={!this.state.validEmail && this.state.errorText? this.state.errorText : undefined}
                        onBlur={(e) => this.familiarEmailHandler((e && e.target && e.target.value) ? e.target.value : '')}
                        autoFocus={(this.state.isSingleResident===true)?true:false}
                    />
                </Grid>
                <Grid item container xs = {12} justify='center' alignItems='flex-end'>
                    <Grid item>
                        <button
                            id='connect_invitation_send_btn'
                            item    
                            style={{...styles.button}}                     
                            className={'appbtn-engage skybluebtn-engage'}
                            onClick={() => this.onSubmitHandler()}
                            onKeyDown={(e) =>{if(e && e.keyCode && e.keyCode===13){this.onSubmitHandler()} }}
                        >
                            Send Code
                        </button>
                        <button 
                            id='connect_invitation_cancel_btn'
                            item
                            style={{...styles.button}}                        
                            className={'appbtn-engage redbtn2-engage'}
                            onClick={() => this.closeModal()}
                        >
                            Cancel
                        </button>
                    </Grid>
                   
                </Grid>
            </Grid>            
        );
    }
    //#endregion

    closeModal = () =>{
        this.setState({
            modalInfo: undefined,
            residents: undefined,
            residentSelected :  undefined,
            community:undefined,
            //Email
            emailText: undefined,
            validEmail: false,
            errorText: undefined
        })
        this.props.onClose()
    }

    render(){
        const device = this.state.rootFontSize? this.state.rootFontSize.name : 'md';

        //percentages
        let modalWidth =(device && device === 'xs') ? 90  :((device && device === 'sm') ? 80 : ((device && device === 'md') ? 50 : 35 )) ;
        let modalHeight=(device && device === 'xs') ? 65  :((device && device === 'sm') ? 65 : ((device && device === 'md') ? 65 : 55 )) ; 

        const top =  50- (modalHeight/2)+ '%';
        const left = 50 - (modalWidth /2)+'%';

        const paperModal= {
            width:modalWidth +'%',
            height:modalHeight +'%',
            top: top, 
            left: left,
        }

        return(
            

             <Modal
                style={{zIndex:18}}
                open={true}
                onClose={() => this.closeModal()}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <Paper elevation={3}  style={{...this.Modal.paperModal, ...paperModal}} color='secondary' id='connect_invitation_modal'>
                    <Grid item container xs={12} justify='center' style={{fontSize:'2.2rem', color:'white', fontWeight:'bold', height:'100%'}}>
                        <Grid item container xs={10}  style={{height:'100%'}}>
                            <Grid item container id='ConnectInvitation_Title_ConnectInvitation' style={{textAlign:'left', height:'20%'}}>
                                Connect Invitation
                            </Grid>
                            {/* Resident Info */}
                            <Grid container style={{height:'20%'}}>
                                <this.InnerResidentComponent/>
                            </Grid>

                            {/* Familiar Info */}
                            <Grid container style={{height:'45%'}}>
                                <this.InnerFamiliarComponent/>
                            </Grid>
                            
                        </Grid>
                    </Grid>                    
                </Paper>
            </Modal>  


        );
    }
}


function mapStateToProps(state){
    const communityData = (state.communityReducer && state.communityReducer.communityData)? state.communityReducer.communityData.map(item =>({_id:item._id, name: item.communityName, communityId: item.communityId, worxHub: (item.worxHub && item.worxHub.active)?  item.worxHub.active : false})) : []; 
    return {
        communityData: communityData,
    };
};


export default connect(mapStateToProps, {getCommunityById, PostRegirtrationInfo})(ConnectInvitationModal);